// MA-582 (D4) — the auth-gate ladder's boot-hold predicate, extracted to a
// PURE module so it can be pinned by an EXECUTED unit test.
//
// sourceTextAssertionRatchet is AT its cap (exact since MA-732, which also made
// it count path.join reads) — no new readFileSync
// source-text pin is possible for App.jsx:908's gate expression — and no
// React render harness exists in this repo. So the expression itself moves
// here, verbatim, and App.jsx calls it instead of inlining it. This pins the
// PREDICATE only, not the card's POSITION below the gate in App.jsx's
// ladder — that ordering is accepted residual risk (see the MA-582 decision
// log in docs/build/BACKLOG.md; e2e/parent-overview.spec.ts @smoke is the
// partial belt for it).

/**
 * @param {{authLoading?: boolean, allowlistLoading?: boolean, cloudLoading?: boolean, bootHydrated?: boolean}} args
 * @returns {boolean} true when the gate ladder should hold at <Loading />.
 */
export function shouldHoldForBoot({ authLoading, allowlistLoading, cloudLoading, bootHydrated }) {
  return !!authLoading || !!allowlistLoading || !!cloudLoading || !bootHydrated;
}
